<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout justify-center wrap>
            <v-flex xs12 md4>
                <device-profile-viewer
                        :data="device_response"
                        :device="device_info"
                        :unsubscribe-handler="unsubscribe"
                        :current_device_name="this.$store.state.device.deviceName"
                ></device-profile-viewer>
            </v-flex>
            <v-flex md8>
                <h2>{{this.$t('publications_section_title')}}</h2>

                <v-flex v-if="device_info !== null">
                    <api-result-viewer :data="api_response"></api-result-viewer>

                    <v-alert :value="items.length === 0 && api_response === 0" color="success" outline>
                        {{this.$t('not_publications_message')}}
                    </v-alert>

                    <template v-if="api_response === 0 && items.length > 0">
                        <v-flex v-for="(item, index) in items" :key="index">
                            <Publication :data="item"/>
                        </v-flex>
                    </template>
                </v-flex>
            </v-flex>
        </v-layout>

        <v-snackbar v-model="snackbar" :color="color" :multi-line="mode" :timeout="timeout">
            {{ text }}
            <v-btn dark flat @click="snackbar = false">X</v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
    import DeviceService from "../apiServices/DeviceService";
    import DeviceProfileViewer from "../components/DeviceProfileViewer";
    import ApiResultViewer from "../components/api/APIResultViewer";
    import Publication from "../components/publications/Publication";

    export default {
        name: "DeviceProfile",
        data(){
            return {
                device_response: 0,
                device_info: null,
                items: [],
                api_response:0,
                snackbar: false,
                color: '',
                mode: true,
                timeout: 6000,
                text: ''
            }
        },
        mounted(){
            this.loadDevice();
        },
        methods: {
            unsubscribe(){
                DeviceService.unsubscribeTo(this.$route.params.device)
                    .then(()=>{
                        this.color = 'success'
                        this.text = this.$t('unsubscribed_message')
                    })
                    .catch(error=>{
                        window.console.log(error)
                        this.color = 'error'
                        this.text = this.$t('unsubscribe_error_message')
                    })
                    .finally(()=>{
                        this.snackbar = true
                    })
            },
            loadDevice(){
                this.device_response = 1;
                new DeviceService(this.$route.params.device).getData()
                    .then(response => {
                        this.device_info = response.data;
                        this.device_response = 2
                        this.loadPublications()
                    })
                    .catch(error => {
                        this.device_response = error
                    })
            },
            loadPublications(){
                this.api_response = 1;
                new DeviceService(this.$route.params.device).getPublications()
                    .then(response => {
                        this.items = response.data;
                        this.api_response = 0;
                    })
                    .catch(error => {
                        this.api_response = error
                    })
            }
        },
        components:{
            Publication,
            ApiResultViewer,
            DeviceProfileViewer}
    }
</script>

<i18n>
    {
        "en": {
            "publications_section_title": "Publications",
            "not_publications_message": "No publications.",
            "unsubscribed_message": "Unsubscribed!!",
            "unsubscribe_error_message": "Error to unsubscribe. :("
        },
        "es": {
            "publications_section_title": "Publicaciones",
            "not_publications_message": "No hay publicaciones.",
            "unsubscribed_message": "Dado de baja!!",
            "unsubscribe_error_message": "Error al dar de baja. :("
        }
    }
</i18n>

